module.exports = __webpack_public_path__ + "ccbf133e2490aafe5667eedc0a800762.svg";